import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import * as moment from 'moment';
import 'moment-timezone';
import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
  selector: 'app-login-failures',
  templateUrl: './login-failures.component.html',
  styleUrls: ['./login-failures.component.css']
})

export class LoginFailuresComponent implements OnInit {
    
  public session_data: any = {};
  public err: any = {};
  public result: any = {};
  public logs = [];
  public form: any = {};
  public page: number = 1;
  public page_length: number = 10;
  public total: number = 0;
  
  public order_by = 0; 
  public table_options = ['desc', 'desc', 'desc', 'desc', 'desc', 'desc'];

  alwaysShowCalendars: boolean;
  showRangeLabelOnInput: boolean;
  keepCalendarOpeningWithRange: boolean;
  public selected: any = {};
  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [
      moment()
        .subtract(1, 'month')
        .startOf('month'),
      moment()
        .subtract(1, 'month')
        .endOf('month')
    ],
    'Last 3 Month': [
      moment()
        .subtract(3, 'month')
        .startOf('month'),
      moment()
        .subtract(1, 'month')
        .endOf('month')
    ]
  };

  constructor(private router: Router, public fb: FormBuilder, private service: DashboardService,
    private spinner: NgxSpinnerService, private login: LoginService) {
    this.session_data.id = login.get_session_data('ieye_session_id');
    this.service.setTitle('Activities | 24ieye');
    this.alwaysShowCalendars = true;
    this.keepCalendarOpeningWithRange = true;
    this.selected = {startDate: moment().subtract(29, 'days').format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD")};
  }

  ngOnInit(): void {
      this.get_activities();
  }
  
  public async get_activities() {
    this.spinner.show();
    var formData: any = new FormData();
    formData.append("start_date", this.selected.startDate);
    formData.append("end_date", this.selected.endDate);
    formData.append("page", this.page);
    formData.append("page_length", this.page_length);
	formData.append("order[column]", this.order_by);
    formData.append("order[dir]", this.table_options[this.order_by]);
    this.result = await this.service.form_actions(formData, 'login_failures');
    this.spinner.hide();
    if (this.result.status == false) {
      if (this.result.code == 202) {
        this.err = {};
        Swal.fire('Alert!', this.result.message, 'error');
      } else {
        this.err = this.result.errors;
      }
    } else {
      this.logs = this.result.data;
      this.total = this.result.totalRecords
    }
  }
  
  datesUpdated(range) {
      if(range.startDate != null && range.endDate != null){
        this.selected = {startDate: moment(range.startDate._d).format("YYYY-MM-DD"), endDate: moment(range.endDate._d).format("YYYY-MM-DD")};
        this.page = 1;
        this.get_activities();
      }
  }
  
  public pageChanged(page) {
    this.page = page;
    this.get_activities();
  }
  
  public data_order_by(column) {
    this.page = 1;
    this.table_options[column] = this.table_options[column] == 'asc' ? 'desc' : 'asc';
    this.order_by = column;
    this.get_activities();
  }
  
  public delete_failures(){
	  Swal.fire({
		title: 'Are you sure?',
		text: "You won't be able to revert this!",
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: 'Yes, delete it!'
	  }).then((action) => {
		if (action.isConfirmed) {
			this.delete_actions(); 
		}
	  });
  }
  
  public async delete_actions(){
	  this.spinner.show();
		var formData: any = new FormData();
		formData.append("start_date", this.selected.startDate);
		formData.append("end_date", this.selected.endDate);
		this.result = await this.service.form_actions(formData, 'delete_failures');
		this.spinner.hide();
		if (this.result.status == false) {
		  if (this.result.code == 202) {
			this.err = {};
			Swal.fire('Alert!', this.result.message, 'error');
		  } else {
			this.err = this.result.errors;
		  }
		} else {
			this.get_activities();
		  Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 });
		}
  }
  
  

}
